export const statusOptions = [
    {key:'Read',value:'true'},
    {key:'Unread',value:'false'}
]